import {NgModule} from '@angular/core';
import {YzLayoutComponent} from './yz-layout/yz-layout.component';
import {YzDefaultIndexComponent} from './yz-default-index/yz-default-index.component';
import {SharedModule} from "../shared.module";


@NgModule({
  declarations: [YzLayoutComponent, YzDefaultIndexComponent],
  imports: [
    SharedModule,
  ]
})
export class LayoutModule {
}
